<template>
  <Button
    variant="fill"
    size="sm"
    shape="rect"
    :active="selected"
    :color="selected ? 'blue2' : 'glass'"
    class="gap-0"
    @click="emit('click')"
  >
    <Icon :icon="icon" class="size-4 shrink-0" />
    <div class="inline-flex gap-1">
      <span>{{ label }}</span>
      <span>
        {{ value }}
      </span>
    </div>
  </Button>
</template>

<script setup lang="ts">
  import { Button, Icon } from '@rapoo/element'

  defineProps<{
    /** 标签文本（行程点 / 灵敏度 / 触感按下 / 触感释放 / 音效按下 / 音效释放） */
    label: string
    /** 已格式化的数值字符串 */
    value: string
    /** 显示在标签左侧的图标 */
    icon: string
    /**
     * 当前块是否处于「选中态」：
     * - activeTab 命中该块所属的 tab、且 mode 命中该侧（或 'both'）。
     * 选中态由 Button 的 color 与 active 属性统一呈现。
     */
    selected?: boolean
  }>()

  const emit = defineEmits<{
    click: []
  }>()
</script>
